import React, { Component } from 'react';

export class SidebarProjectVersion extends Component {

    constructor(props) {
        super(props);

        this.versionRef = process.env.REACT_APP_PROJECT_VERSION_REF;
        this.versionCommit = process.env.REACT_APP_PROJECT_VERSION_COMMIT;
    }

    render() {
        if (!this.versionRef) {
            return null;
        }

        return (
            <div className="sidebar-version">
                Version { this.versionRef.length > 10 ? this.versionRef.substring(0, 10) + "…" : this.versionRef }
                { this.versionCommit ? " (" + this.versionCommit.substring(0, 8) + ")" : null }
            </div>
        )
    }
}

export default SidebarProjectVersion;
